module.exports = __webpack_public_path__ + "img/small_flower.b42448f5.png";